:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

:host {
  display: block;
}
@media (min-width: 992px) {
  :host {
    margin-inline-end: 30px;
  }
}

a,
button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 5px;
  padding: 4px;
  text-decoration: none;
  cursor: pointer;
  text-align: left;
}
a:hover,
button:hover {
  background-color: #edf1f4;
}
a:focus-visible,
button:focus-visible {
  outline: 2px solid #009cc2;
  outline-offset: -2px;
}
a.disabled,
button.disabled {
  pointer-events: none;
}
a.disabled span,
button.disabled span {
  color: #a3bac8;
}
a.uppercase span,
button.uppercase span {
  text-transform: uppercase;
}

span {
  color: #002b49;
  font-family: "Bosch Sans";
  font-size: 16px;
  line-height: 24px;
}
@media (min-width: 1200px) {
  span {
    font-family: "Bosch Sans";
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.16px;
    line-height: 24px;
  }
}

.title,
.selected {
  font-family: "Bosch Sans";
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
}
@media (min-width: 1200px) {
  .title,
  .selected {
    font-family: "Bosch Sans";
    font-size: 14px;
    line-height: 24px;
    font-weight: bold;
    letter-spacing: 0.16px;
  }
}
.title dc-ui-icon.title-link-icon,
.selected dc-ui-icon.title-link-icon {
  margin-left: 8px;
  vertical-align: middle;
  height: 18px;
  fill: #002b49;
}
.title dc-ui-icon.title-link-icon--disabled,
.selected dc-ui-icon.title-link-icon--disabled {
  fill: #a3bac8;
}

.item-arrow {
  margin-left: auto;
}